import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import { en } from "../i18n/en";
import { de } from "../i18n/de";

const LanguageContext = createContext();

const translations = { en, de };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("portfolio-language");
    if (saved) return saved;
    const browserLang = navigator.language.split("-")[0];
    return translations[browserLang] ? browserLang : "en";
  });

  useEffect(() => {
    localStorage.setItem("portfolio-language", language);
    document.documentElement.lang = language;
  }, [language]);

  const t = useMemo(() => {
    return (key) => {
      const keys = key.split(".");
      let value = translations[language];
      for (const k of keys) {
        if (value && value[k]) {
          value = value[k];
        } else {
          return key; // Return the key if translation is missing
        }
      }
      return value;
    };
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      t,
    }),
    [language, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
